// @ts-check
/** @typedef {import("actions/scene.types").ModeType} ModeType */

/** @type {{photoPrint: ModeType, canvas: ModeType, mask: ModeType, poster: ModeType, calendar: ModeType, photoBook: ModeType}} */
export default {
  photoPrint: 'photo-print',
  canvas: 'canvas',
  mask: 'mask',
  poster: 'poster',
  calendar: 'calendar',
  photoBook: 'photo-book',
};
